import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { ECacheKeys } from 'cache/CacheKeys';
import type { IAddress } from 'api/resources/address';
import { getAddresses } from 'api/resources/address';

export const useGetAddresses = (
	filter?: string,
	options?: UseQueryOptions<IAddress[]>
) => {
	const query = useQuery({
		queryKey: [ECacheKeys.Addresses, filter],
		queryFn: () => getAddresses(filter),
		refetchInterval: false,
		meta: {
			error:
				'There was an error fetching the address information, please try again',
		},
		refetchOnWindowFocus: false,
		...(options || {}),
	});

	return query;
};
